<span class="container" *ngIf="shouldDisplayValue()" [ngClass]="{ 'negative-value': isNegative() }">
  <b>$</b>
  <span>{{ +params.value | number: '1.2-2' }}</span>
</span>
